import { gql } from '@apollo/client'
import { ADVISOR_ENGAGEMENT_CHAT_THREAD_FRAGMENT } from '@src/gql/fragments/AdvisorEngagementChatThreadFragment'

/**
 * Full engagement selection used by advisorBoard and endAdvisorEngagement.
 * Nav and list UIs share this document — a lighter nav-only fragment was considered
 * but skipped (cache shape would diverge from board consumers that need profile fields).
 */
export const ADVISOR_ENGAGEMENT_FRAGMENT = gql`
  fragment AdvisorEngagementFragment on ScoAdvisorEngagement {
    id
    advisorEngagementId
    founderUserId
    advisorUserId
    advisorName
    advisorEmail
    sourceKey
    isAI
    statusKey
    categoryKey
    whyText
    skillTagTitles
    industryKeys
    candidateCount
    currentUserCanEdit
    notifyMatches
    groupRequestId
    companyId
    invitedAt
    activatedAt
    endedAt
    chatLastActiveAt
    createdAt
    source {
      id
      key
      title
    }
    status {
      id
      key
      title
    }
    category {
      id
      key
      title
    }
    company {
      id
      companyId
      name
    }
    groupRequest {
      id
      groupRequestId
      publishStatusKey
      title
    }
    currentAgreement {
      id
      advisorAgreementId
      statusKey
      status {
        id
        key
        title
      }
    }
    advisorUser {
      id
      userId
      slug
      firstName
      lastName
      fullName
      displayName
      email
      pictureUrl
      shortBio
      bio
      location
      linkedin
      lastActiveAt
      company {
        id
        name
        logoUrl
        industries {
          id
          title
        }
      }
      userSkills(order: [["experienceStrength", "desc"]]) {
        id
        title
        experienceStrength
      }
      advisorProfile {
        id
        advisorProfileId
        responsesCount
        foundersHelpedCount
        headline
        bioForAdvising
        availabilityHoursPerMonth
        sessionBookingUrl
        hourlyRate
        canAcceptSessions
        categories {
          id
          key
          title
        }
      }
    }
    founderUser {
      id
      userId
      slug
      fullName
      displayName
      pictureUrl
      title
      shortBio
      company {
        id
        name
      }
    }
    ...AdvisorEngagementChatThreadFragment
  }
  ${ADVISOR_ENGAGEMENT_CHAT_THREAD_FRAGMENT}
`
